import { atom } from 'jotai';

import { UserCurrencyResponseType } from '../index.js';

export type UserCurrencyState = UserCurrencyResponseType | null;

export const userCurrencyStore = atom<UserCurrencyState>(null);
